// extracted by mini-css-extract-plugin
module.exports = {"input":"ClientProfileDisplay_input_2lr-S","infoLabel":"ClientProfileDisplay_infoLabel_2duSc","infoText":"ClientProfileDisplay_infoText_3X3dF"};